export default "__VITE_ASSET__TTrnEBaR__"